import { startAuthentication, startRegistration } from '@simplewebauthn/browser';
import { meSchema, webauthnOptionsSchema, type Me } from '@map/shared';
import { api } from '../lib/api.js';

export function passkeysSupported(): boolean {
  return typeof window !== 'undefined' && 'PublicKeyCredential' in window;
}

export async function signInWithPasskey(): Promise<Me> {
  const options = await api.request('/auth/passkey/login/options', {
    method: 'POST',
    schema: webauthnOptionsSchema,
  });
  const response = await startAuthentication({ optionsJSON: options as never });
  return api.request('/auth/passkey/login/verify', {
    method: 'POST',
    body: { response },
    schema: meSchema,
  });
}

export async function registerPasskey(name: string): Promise<void> {
  const options = await api.request('/auth/passkey/register/options', {
    method: 'POST',
    schema: webauthnOptionsSchema,
  });
  const response = await startRegistration({ optionsJSON: options as never });
  await api.request('/auth/passkey/register/verify', {
    method: 'POST',
    body: { response, name },
    schema: webauthnOptionsSchema,
  });
}
